@if (work | async; as work) {
  <app-calendar
    [work]="work"
    [workItems]="(workItems | async) ?? []"
    [timerItems]="(timerItems | async) ?? []"
    [selectedDate]="(selectedDate | async)!"
    [selectedMonth]="(selectedMonth | async)!"
    [warningDays]="(warningDays | async)!"
    [weekStatusMessage]="weekStatusMessage | async"
    [pendingTimeEntryChange]="pendingTimeEntryChange"
    (selectedDateChange)="selectedDateChange($event)"
    (selectedMonthChange)="selectedMonth.next($event)"
    (createWork)="openCreateWork($event)"
    (editWork)="openEditWork($event)"
    (showTimer)="showTimer($event)"
    (timeEntryChange)="applyTimeEntryChange($event)"
  >
  </app-calendar>
}
